module.exports = __webpack_public_path__ + "static/media/product16.9740f956.jpg";